<template>
  <el-dialog
    title="费用清单列表"
    :visible.sync="dialogVisible"
    width="80%"
    :before-close="handleClose"
    v-if="dialogVisible"
    append-to-body
  >
    <div>
      <SiruiSearch
        ref="storeDataSearch"
        :query="query"
        :columns="searchFormColumns"
        labelWidth="130px"
        :defaultRow="2"
        @resetBtnClick="resetBtnClickHandler"
        @searchBtnClick="queryBtnClickHandler"
      ></SiruiSearch>
      <SiruiTable
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="loading"
        :data="tableData"
        :columns="columnList"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
        <vxe-table-column type="seq" width="50" title="序号"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
        >
        </vxe-table-column>
      </SiruiTable>
    </div>
    <div class="btn-group">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="exportExcel">确定导出</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { defaultSearchFormColumns, defaultColumnList } from './index.js';
  export default {
    name: 'ExportBillDialog',
    data() {
      return {
        dialogVisible: false,
        rowData: [],
        query: {
          customerNo: '',
          customerName: '',
          businessDateStart: '',
          businessDateEnd: '',
          inboundDateStart: null,
          inboundDateEnd: null,
          outboundDateStart: null,
          createDateStart: null,
          createDateEnd: null,
          expenseNos: [],
        },
        multipleSelection: [],
        loading: false,
        tableData: [],
        menuButtonList: [],
      };
    },
    computed: {
      searchFormColumns() {
        return defaultSearchFormColumns(this);
      },
      columnList() {
        return defaultColumnList(this);
      },
    },
    methods: {
      getMin(list) {
        var min = list[0];
        for (let i = 1; i < list.length; i++) {
          if (list[i] < min) {
            min = list[i];
          }
        }
        return min;
      },
      getMax(list) {
        var max = list[0];
        for (let i = 1; i < list.length; i++) {
          if (list[i] > max) {
            max = list[i];
          }
        }
        return max;
      },
      openModal(rowData = []) {
        this.rowData = rowData;
        this.query.expenseNos = rowData
          .map((item) => item.expenseNo)
          .filter((item) => Boolean(item));
        this.query.customerName = rowData[0].customerName;
        this.query.customerNo = rowData[0].customerNo;
        this.query.businessDateStart = this.getMin(rowData.map((item) => item.periodDateFrom));
        this.query.businessDateEnd = this.getMax(rowData.map((item) => item.periodDateUntil));
        this.dialogVisible = true;
        this.initTableData();
      },
      handleClose() {
        this.dialogVisible = false;
      },
      resetBtnClickHandler() {
        this.query.inboundDateStart = '';
        this.query.inboundDateEnd = '';
        this.query.outboundDateStart = '';
        this.query.createDateStart = '';
        this.query.createDateEnd = '';
      },
      queryBtnClickHandler() {
        this.initTableData();
      },
      // 表格选择行
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      async initTableData() {
        const {
          data: { code, data },
        } = await this.$axios.post(
          '/financial/receivableSettlementExpense/detail/query',
          this.query
        );
        if (code == 0) {
          this.tableData = data;
        } else {
          console.error('获取数据失败');
        }
      },
      async exportExcel() {
        const postData = {
          ...this.query,
          expenseDetailIds: this.multipleSelection.map((item) => item.id),
        };
        const { data } = await this.$axios.post(
          '/financial/receivableSettlementExpense/detail/export',
          postData
        );
        if (data.code === 0) {
          window.location.href = data.data.word;
          this.$message.success('导出成功');
        } else {
          this.$message.error('导出失败');
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn-group {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
</style>
